import { call, put, all, takeLatest } from "redux-saga/effects";
import { Api } from "../api";
import * as trackingActions from "../actions/tracking";
import * as authActions from "../actions/auth";

function* getUserLocationTracking(action) {
  try {
    const res = yield call(Api.tracking.getUserLocationTracking, action.payload);
    yield put({
      type: trackingActions.GET_USER_TRACKING_SUCCESS,
      payload: {trackingData: res.data.data.filtereddata, inspectorData: res.data.data.Inspectors},
    });
  } catch (err) {
    yield put({
      type: trackingActions.GET_USER_TRACKING_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getInspectors(action) {
  try {
    const res = yield call(Api.tracking.getInspectors, action.payload);
    yield put({
      type: trackingActions.GET_INSPECTORS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: trackingActions.GET_INSPECTORS_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* getUserSummaryTracking(action) {
  try {
    const res = yield call(Api.tracking.getUserSummaryTracking, action.payload);
    yield put({
      type: trackingActions.GET_USER_TRACKING_SUMMARY_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    yield put({
      type: trackingActions.GET_USER_TRACKING_SUMMARY_FAIL,
      payload: { error: err.message },
    });
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

export default all([
  takeLatest(trackingActions.GET_USER_TRACKING_REQUEST, getUserLocationTracking),
  takeLatest(trackingActions.GET_USER_TRACKING_SUMMARY_REQUEST, getUserSummaryTracking),
  takeLatest(trackingActions.GET_INSPECTORS_REQUEST, getInspectors),
  ]
);
